import {
  ApiBlueprint,
  createFrontendModule,
} from '@backstage/frontend-plugin-api';
import {
  ALL_RELATION_PAIRS,
  ALL_RELATIONS,
  catalogGraphApiRef,
  DefaultCatalogGraphApi,
} from '@backstage/plugin-catalog-graph';
import { CODEX_RELATION_PAIRS } from 'codex-relations';

// The graph card and page only draw relations this API knows about.
const catalogGraphApi = ApiBlueprint.make({
  params: defineParams =>
    defineParams({
      api: catalogGraphApiRef,
      deps: {},
      factory: () =>
        new DefaultCatalogGraphApi({
          knownRelations: [...ALL_RELATIONS, ...CODEX_RELATION_PAIRS.flat()],
          knownRelationPairs: [...ALL_RELATION_PAIRS, ...CODEX_RELATION_PAIRS],
          defaultRelationTypes: { exclude: [] },
        }),
    }),
});

export const catalogGraphModule = createFrontendModule({
  pluginId: 'catalog-graph',
  extensions: [catalogGraphApi],
});
